/**
 * Created by intellicar-rinas on 4/6/18.
 */
const messages = [
    {msg: 'yes?'},
    {msg: 'yeah?'},
    {msg: 'What can i do for you?'},
    {msg: 'yes?'},
    {msg: 'Good evening!'},
    {msg: 'Hi'},
    {msg: 'yeah?'},
    {msg: 'can i help you?'},
    {msg: 'Hi'},
    {msg: 'looking for anything?'},
];

export default (name)=>{
    let index = Math.floor(messages.length * Math.random());
    return messages[index].msg;
}